import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { moveToChangeSubscription } from 'actions/billing/subscription_modal';
import { canManageBillingSelector, featureTierSelector } from 'features/billing';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { useNeedsUpgrade } from './use_needs_upgrade';
const containerCss = "c1m2l4yo";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Informer = () => {
  const dispatch = useDispatch();
  const track = useTrack();
  const featureKeyToUpgradeTo = useNeedsUpgrade();
  const canManageBilling = useSelector(canManageBillingSelector);
  const featureTier = useSelector(state => featureTierSelector(state, {
    featureKey: featureKeyToUpgradeTo
  }));
  useEffect(() => {
    if (featureKeyToUpgradeTo && canManageBilling) {
      track({
        name: TRACKING_EVENT_NAMES.PAYWALL_SHOWN,
        entities: ['user', 'organization', 'attribution'],
        properties: {
          paywall_feature: featureKeyToUpgradeTo,
          paywall_type: 'inline',
          plan_required: featureTier.toLowerCase()
        }
      });
    }
  }, [track, featureKeyToUpgradeTo, canManageBilling, featureTier]);
  if (!featureKeyToUpgradeTo) return null;
  if (!canManageBilling) {
    return <Container>
        <Banner title={I18n.t('publisher.enforcement.subscription_needs_upgrade')}>
          {I18n.t('publisher.enforcement.contact_calendly_admin')}
        </Banner>
      </Container>;
  }
  const bannerContent = {
    team_scheduling: I18n.t('publisher.enforcement.teams.upgrade_for_team_events'),
    manage_all_users: I18n.t('publisher.enforcement.manage_users_upgrade')
  }[featureKeyToUpgradeTo];
  const handleUpgradeClick = () => {
    dispatch(moveToChangeSubscription({
      preface: false,
      featureKey: featureKeyToUpgradeTo,
      onSuccess: () => window.location.reload()
    }));
  };
  return <Container>
      <Banner footer={<Button onClick={handleUpgradeClick}>{I18n.t('publisher.billing.action.upgrade')}</Button>}>
        {bannerContent}
      </Banner>
    </Container>;
};

require("./informer.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./informer.js");